import React from 'react';
import { News } from '../News.interface';
import './SingleNewsPreview.css';
import { Link } from 'react-router-dom';
import PhotoDisplay from 'libs/components/PhotoDisplay/PhotoDisplay';
import { GalleryImage } from 'components/Main/PhotoSection/Gallery.interface';
import { environments } from 'environments/environments';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from 'react-share';

interface Props { news: News, full?: boolean }
interface State { [key: string]: any }

export default class SingleNewsPreview extends React.Component<Props, State> {
  state = {
    photoPreviewActive: false,
    activePhoto: 0
  }

  images = [] as GalleryImage[];

  componentDidMount() {
    this.fillImages();
  }

  fillImages() {
    const images = this.props.news.images ? [...this.props.news.images.split(';;')] : [];
    this.images = images.map((image, index) => {
      const virtualImage = new Image();
      virtualImage.onload = () => {
        const [width, height] = [Math.max(virtualImage.naturalWidth, 72), Math.max(virtualImage.naturalHeight, 72)];
        this.images[index].height = height;
        this.images[index].width = width;
        // console.log(width, height);
        this.setState({});
      }
      virtualImage.src = this.getImageURL(image);
      virtualImage.remove();
      return {
        category: 'ILUSTRACE',
        filename: this.getImageURL(image),
        thumbnail: '',
        gallery: 0,
        height: 160,
        id: index,
        order: 0,
        public: 1,
        text: '',
        time: 0,
        width: 160
      }
    });
  }

  openImagePreview(index: number) {
    this.setState({ photoPreviewActive: true, activePhoto: index });
  }

  closeImagePreview() {
    this.setState({ photoPreviewActive: false, activePhoto: 0 });
  }

  getImageURL(imageURL: string) {
    if (imageURL.includes('http')) {
      return imageURL;
    }
    return `${environments.server}${imageURL}`;
  }

  render() {
    const props = this.props;
    const news = props.news;
    const date = news.time ? new Date(+news.time) : new Date(+news.addTime);
    // TODO: Add name to images (for alt text and image display)
    const imageArray = this.images.length ? this.images : [];
    const linksArray: { url: string, name: string }[] = (news.links ? [...news.links.replace(/&quot;/g, '"').split(';;')] : []).map(link => {
      const splitLink = link.split(';');
      return {
        url: splitLink[1] || '',
        name: splitLink[0] || splitLink[1] || ''
      }
    });
    const renderDate = `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
    // const renderNews = news.shortText.split('\n').map((line, index) => <p key={index}>{line} </p>);
    const renderNewsString = (news.shortText.split('\n').map((line, index) => `<p key=${index}>${line} </p>`)).join('');
    const renderImages = imageArray.map((image, index) => <img className="news-image" src={image.filename} alt='' key={index} onClick={() => this.openImagePreview(index)} />);
    const renderLinks = linksArray.map((link, index) => (
      link.url[0] === "/"
        ? <Link className="news-link" to={link.url} key={index}><li>{link.name}</li></Link>
        : <a className="news-link" href={link.url} key={index} target="_blank" rel="noopener noreferrer">
          <li>{link.name}</li>
        </a>
    ));
    // console.log(props.full);
    const url = `${environments.server}/novinky/${news.id}`;
    return (
      <div className={"section single-news-preview" + (props.full ? " full-news" : "")}>
        <Link to={'/novinky/' + news.id}>
          <p className="datum">{renderDate}</p>
        </Link>
        <div className="news-body">
          <div dangerouslySetInnerHTML={{ __html: renderNewsString }}></div>
          {/* {renderNews} */}
          {props.full
            ? <ul className="news-links">{renderLinks}</ul>
            : null
          }
          <div className="news-images">
            {renderImages}
          </div>
          {props.full
            ? null
            : <ul className="news-links">{renderLinks}</ul>
          }
        </div>
        <div className="news-shares">
          <FacebookShareButton url={url} hashtag="#doktortriceratops" className='share'>
            <FacebookIcon size={24} />Sdílet
          </FacebookShareButton>
          <TwitterShareButton url={url} title={'\n'} hashtags={['doktortriceratops']} className="tweet">
            <TwitterIcon size={24} />Tweet
          </TwitterShareButton>
          {/* TODO - přidat "Copy link" */}
        </div>
        {this.state.photoPreviewActive
          ? <PhotoDisplay activePhoto={this.state.activePhoto} photoList={this.images} close={this.closeImagePreview.bind(this)} />
          : null
        }
      </div>
    );
  }
}